import { setupGanttConfig } from './ganttConfig';
import { ganttGeneralConfig } from '../gantt-general-config';
import { configExportPlugin } from '../../../assets/gantt/ext/dhtmlxgantt_export';

function initGantt(ganttInstance, data, visualizationConfig, t, sector) {
  const ganttConfig = setupGanttConfig(visualizationConfig, ganttInstance);
  Object.keys(ganttConfig).forEach((key) => {
    ganttInstance.config[key] = ganttConfig[key];
  });

  ganttGeneralConfig({
    gantt: ganttInstance,
    sector: sector
  });
  // Initialize gantt chart
  ganttInstance.init('scheduleContainer');
  const activitiesToLoad = data.data.map((act) => {
    act.custom_sucessors = '';
    act.old_custom_sucessor = '';
    act.custom_predecessors = '';
    act.old_custom_predecessor = '';
    return act;
  });

  ganttInstance.parse({
    data: activitiesToLoad,
    links: data.links
  });

  ganttInstance.sort('correlative_id', false);
  if (ganttInstance.getTaskByTime().length !== 0) {
    ganttInstance.getGridColumn('buttons').label = t('buttons_label_only');
  }

  configExportPlugin(ganttInstance, t);

  return ganttInstance;
}

export { initGantt };
